"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = detectBusinessUnit;

var _types = require("../@types");

// gets the business resource from either a window level object or the url
function detectBusinessUnit() {
  var businessResource = _types.BusinessUnit.WEDDING_REGISTRY;
  var isWeddingSignup = window.zolaNav && window.zolaNav.isWeddingSignup;
  var isRegistrySignup = window.zolaNav && window.zolaNav.isRegistrySignup;
  var isInvitationsSignup = window.zolaNav && window.zolaNav.isInvitationsSignup;
  var path = window.location.pathname;
  var isInvitationsUrl = path.indexOf('wedding-planning/invites-paper') > -1 || path.indexOf('wedding-planning/paper') > -1 || path.indexOf('wedding-planning/universal') > -1 || path.indexOf('wedding-planning/invitations') > -1 || path.indexOf('wedding-planning/save-the-date') > -1 || path.indexOf('wedding-planning/change-the-date') > -1 || path.indexOf('wedding-planning/projects') > -1 || path.indexOf('/wedding-planning/thank-you-cards') > -1 || path.indexOf('/wedding-planning/menus') > -1 || path.indexOf('/wedding-planning/enclosures') > -1 || path.indexOf('/wedding-planning/place-cards') > -1 || path.indexOf('/wedding-planning/holiday-cards') > -1 || path.indexOf('/wedding-planning/programs') > -1 || path.indexOf('/wedding-planning/suites/shop') > -1;
  var isDigitalUrl = path.indexOf('/wedding-planning/digital/save-the-date') > -1;
  var isAlbumsUrl = path.indexOf('wedding-albums') !== -1;
  var isShopOrSearchUrl = path.indexOf('/shop') > -1 || path.indexOf('/search') > -1;
  var isWeddingUrl = path.indexOf('wedding') > -1 && !(path.indexOf('wedding-registry') > -1) && !isInvitationsUrl && !isShopOrSearchUrl;
  var isMarketplaceUrl = path.indexOf('/wedding-vendors') === 0 || path.indexOf('/inspiration/onboard') === 0 || path.indexOf('/inspire') === 0;
  var isInspirationUrl = path.indexOf('/inspiration') === 0;
  var isHomeStore = path.indexOf('homestore') > -1; // if the url is wedding or we've set the window bool to wedding
  // check flags first and then url, break href checks into separate booleans

  if (isDigitalUrl) {
    businessResource = _types.BusinessUnit.DIGITAL_SAVE_THE_DATE;
  } else if (isWeddingSignup) {
    businessResource = _types.BusinessUnit.WEDDINGS;
  } else if (isRegistrySignup) {
    businessResource = _types.BusinessUnit.WEDDING_REGISTRY;
  } else if (isInvitationsSignup) {
    businessResource = _types.BusinessUnit.INVITATIONS;
  } else if (isInvitationsUrl) {
    businessResource = _types.BusinessUnit.INVITATIONS;
  } else if (isAlbumsUrl) {
    businessResource = _types.BusinessUnit.PHOTOBOOK;
  } else if (isMarketplaceUrl) {
    businessResource = _types.BusinessUnit.MARKETPLACE;
  } else if (isInspirationUrl) {
    businessResource = _types.BusinessUnit.INSPIRATION;
  } else if (isWeddingUrl) {
    businessResource = _types.BusinessUnit.WEDDINGS;
  } else if (isHomeStore) {
    businessResource = _types.BusinessUnit.STORE;
  }

  return businessResource;
}